const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PROCESSO_TIPO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PROCESSO_TIPO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'PROCESSO_TIPO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        default:
            return state;
    }
}
